var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),(_vm.showExitButton)?_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("X")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }